
import '@mescius/wijmo.styles/wijmo.scss';
import '../../../assets/app.scss';
import '@mescius/wijmo.cultures/wijmo.culture.ja';

import * as React from 'react';
import {createRoot} from 'react-dom/client';
import { Button } from 'react-bootstrap';
import * as Wijmo from '@mescius/wijmo';
import * as WjInput from '@mescius/wijmo.input';
import { WjTextBox } from '../components/WijmoControl';
import { useLoginStore } from './stores/loginStore';
import { ErrorMessage } from '../components/ErrorMessage';
import { AppProvider } from '../components/AppProvider';
import { useAppComponentStore } from '../components/stores/appComponentStore';

/**
 * ログイン
 */
export const Login = () => {
    const appComponentStore = useAppComponentStore();
    const p = useAppComponentStore((state) => state.progress);
    const loginStore = useLoginStore();

    React.useEffect(() => {
    
    },[]);

    /**
     * ログイン
     * @param e 
     */
    const onClickLogin = (e:React.MouseEvent) => {
        loginStore.thunkLogin(appComponentStore, loginStore.userCd ,loginStore.password);
    }

    /**
     * ユーザーCD変更
     * @param target
     * @param e 
     */
    const onChangeUserCd = (target:WjInput.ComboBox<any> ,e:Wijmo.EventArgs) => {
        loginStore.changeUserCd(target.text);
    }

    /**
     * パスワード変更
     * @param target 
     * @param e 
     */
    const onChangePassword = (target:WjInput.ComboBox<any> ,e:Wijmo.EventArgs) => {
        loginStore.changePassword(target.text);
    }

    return (
        <div className="login-container">
            <div className="login-card bg-white">
                <div className="w-100 text-center">
                    <h2>販売管理コントロールパネル</h2>
                </div>
                <form className="pt-3">
                    <div className="row">
                        <div className="col-12">
                            <WjTextBox
                                id="userCd"
                                label="ユーザーCD"
                                inputType="email"
                                textChanged={onChangeUserCd}
                                text={loginStore.userCd}
                            />
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-12">
                            <WjTextBox
                                id="password"
                                label="パスワード"
                                inputType="password"
                                textChanged={onChangePassword}
                                text={loginStore.password}
                            />
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-12 pt-4">
                            <Button 
                                variant="success"
                                onClick={onClickLogin} 
                                className="w-100">ログイン</Button>
                        </div>
                    </div>
                </form>
                <ErrorMessage messages={loginStore.errMessage} />
            </div>
        </div>
    )
}

const container = document.getElementById("app");
if(container != null){
    const root = createRoot(container);
    root.render(
        <AppProvider>
            <Login />
        </AppProvider>
    );
}